import { TenantEntity } from '../TenantEntity'
import { getUserDefaultDepartment, getUserDefaultDepartmentByOffice, getUserDepartmentOffices, getUsersByPrivilegeDetail } from '@/api/user'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import { ApiCacheManage } from '@/utils/commonUtil'
import { getUserDepartmentTeamNew, getAllUsersByOffice, getAllUsersByDepartments } from '@/api/user'
import { getFilterCacheList, getCacheListByKey, cacheKeys } from '@/utils/basicDataCache'
import $store from '@/store'

// getUserDepartmentOffices缓存管理
export const getUserDepartmentOfficesCache = new ApiCacheManage(getUserDepartmentOffices, params => `${params.category}-${params.shape}-${params.userId}`)
// getUsersByPrivilegeDetail缓存管理
export const getUsersByPrivilegeDetailCache = new ApiCacheManage(getUsersByPrivilegeDetail, params => `${params.category}-${params.shape}-${params.point}-${params.officeId}-${params.active}`)

export class User extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get userId() {
    return this._data.userId
  }
  set userId(userId) {
    this._data.userId = userId || 0
  }
  get login() {
    return this._data.login
  }
  set login(login) {
    this._data.login = login
  }
  get chineseName() {
    return this._data.chineseName
  }
  set chineseName(chineseName) {
    this._data.chineseName = chineseName
  }
  get englishName() {
    return this._data.englishName
  }
  set englishName(englishName) {
    this._data.englishName = englishName
  }
  get password() {
    return this._data.password
  }
  set password(password) {
    this._data.password = password
  }
  get email() {
    return this._data.email
  }
  set email(email) {
    this._data.email = email
  }
  get phone() {
    return this._data.phone
  }
  set phone(phone) {
    this._data.phone = phone
  }
  get cell() {
    return this._data.cell
  }
  set cell(cell) {
    this._data.cell = cell
  }
  get fax() {
    return this._data.fax
  }
  set fax(fax) {
    this._data.fax = fax
  }
  get active() {
    return this._data.active
  }
  set active(active) {
    this._data.active = active || false
  }
  get expirationDate() {
    return this._data.expirationDate
  }
  set expirationDate(expirationDate) {
    this._data.expirationDate = expirationDate
  }
  get defaultOfficeId() {
    return this._data.defaultOfficeId
  }
  set defaultOfficeId(defaultOfficeId) {
    this._data.defaultOfficeId = defaultOfficeId || 0
  }
  get defaultDepId() {
    return this._data.defaultDepId
  }
  set defaultDepId(defaultDepId) {
    this._data.defaultDepId = defaultDepId || 0
  }
  get netCode() {
    return this._data.netCode
  }
  set netCode(netCode) {
    this._data.netCode = netCode
  }
  get manager() {
    return this._data.manager
  }
  set manager(manager) {
    this._data.manager = manager || 0
  }
  get type() {
    return this._data.type
  }
  set type(type) {
    this._data.type = type || 0
  }
  get externalUser() {
    return this._data.externalUser || false
  }
  set externalUser(externalUser) {
    this._data.externalUser = externalUser
  }
  get partnerUUID() {
    return this._data.partnerUUID
  }
  set partnerUUID(partnerUUID) {
    this._data.partnerUUID = partnerUUID
  }
  get userCode() {
    return this._data.userCode
  }
  set userCode(userCode) {
    this._data.userCode = userCode
  }
  get firstLoginDate() {
    return this._data.firstLoginDate
  }
  set firstLoginDate(firstLoginDate) {
    this._data.firstLoginDate = firstLoginDate
  }
  get probation() {
    return this._data.probation
  }
  set probation(probation) {
    this._data.probation = probation || false
  }
  get defaultOfficeName() {
    return this._data.defaultOfficeName
  }
  set defaultOfficeName(defaultOfficeName) {
    this._data.defaultOfficeName = defaultOfficeName
  }
  get defaultDepName() {
    return this._data.defaultDepName
  }
  set defaultDepName(defaultDepName) {
    this._data.defaultDepName = defaultDepName
  }
  get roles() {
    return this._data.roles
  }
  set roles(roles) {
    this._data.roles = roles
  }
  get authorizeRole() {
    return this._data.authorizeRole
  }
  set authorizeRole(authorizeRole) {
    this._data.authorizeRole = authorizeRole || false
  }
  get trackingTemplateUuids() {
    return this._data.trackingTemplateUuids
  }
  set trackingTemplateUuids(trackingTemplateUuids) {
    this._data.trackingTemplateUuids = trackingTemplateUuids
  }
  get isDisableLogin() {
    return this._data.isDisableLogin
  }
  set isDisableLogin(isDisableLogin) {
    this._data.isDisableLogin = isDisableLogin || false
  }
  static async getUserDepartmentOffices(category, shape, userId) {
    const res = await getUserDepartmentOfficesCache.execute({ category, shape, userId })
    return res.data
  }
  async getDefaultDepartment(category, shape, officeId) {
    if (!this._data.userId) {
      return null
    }
    return await getUserDefaultDepartment({ category, shape, userId: this._data.userId, officeId }).then(res => res.data || null)
  }
  async getUserDefaultDepartmentByOffice(category, shape, officeId) {
    if (!this._data.userId) {
      return null
    }
    return await getUserDefaultDepartmentByOffice({ category, shape, userId: this._data.userId, officeId }).then(res => res.data || null)
  }
  static async getUsersByPrivilegeDetail(category, shape, point, officeId, active = null) {
    officeId = officeId || null
    const res = await getUsersByPrivilegeDetailCache.execute({ category, shape, point, officeId, active })
    return res.data
  }
  static async getUserById(userId) {
    return await getObjectByCache(basicCacheKeys.basic_data_User, 'userId', parseInt(userId))
  }
  static getUserByIdSync(userId) {
    return getObjectByCache(basicCacheKeys.basic_data_User, 'userId', parseInt(userId))
  }
  /**
   * 同组部门下的用户
   */
  static async getUserDepartmentTeam() {
    const departments = await getFilterCacheList(cacheKeys.basic_data_Department)
    const departmentKeys = []
    const currentOfficeUuid = $store.getters.currentOfficeUuid
    if (departments && departments.length > 0) {
      for (const item of departments) {
        if (item.officeUuid === currentOfficeUuid && item.departmentId > 0) {
          departmentKeys.push(item.uuid)
        }
      }
    }
    if (!departmentKeys || departmentKeys.length <= 0) {
      return []
    }
    // 同组部门下的用户
    const resData = await getUserDepartmentTeamNew(departmentKeys, $store.getters.currentOfficeId)
    return resData.data
  }

  /**
   * 同组部门下的用户
   */
  static async getUserDepartmentTeamByOfficeUuid(officeUuid) {
    const departments = await getFilterCacheList(cacheKeys.basic_data_Department)
    const departmentKeys = []
    const currentOfficeUuid = officeUuid
    if (departments && departments.length > 0) {
      for (const item of departments) {
        if (item.officeUuid === currentOfficeUuid && item.departmentId > 0) {
          departmentKeys.push(item.uuid)
        }
      }
    }
    if (!departmentKeys || departmentKeys.length <= 0) {
      return []
    }
    // 同组部门下的用户
    const resData = await getUserDepartmentTeamNew(departmentKeys, officeUuid)
    return resData.data
  }

  /**
   * 同部门下的所有用户
   */
  static async getAllUsersByDepartments() {
    const departments = await getCacheListByKey(cacheKeys.basic_data_Department)
    const departmentKeys = []
    if (departments && departments.length > 0) {
      for (const item of departments) {
        if (item.departmentId > 0) {
          departmentKeys.push(item.uuid)
        }
      }
    }
    if (departmentKeys.length <= 0) {
      return []
    }
    const res = await getAllUsersByDepartments(departmentKeys)
    return res.data
  }

  // 获取该公司下所有的用户
  static async getAllUsersByOffice(officeId) {
    return await getAllUsersByOffice({ officeId }).then(res => res.data)
  }
}
